import CityPageTemplate from "../city-template/CityPageTemplate";
import { georgetownDeConfig } from "./data";

export default function GeorgetownDePage() {
  return <CityPageTemplate config={georgetownDeConfig} />;
}